
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmNoackIec as ObiAlarmNoackIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-noack-iec.js';
 
 
 

 
 export const ObiAlarmNoackIec = createComponent({
   react: React,
   tagName: 'obi-alarm-noack-iec',
   elementClass: ObiAlarmNoackIecElement,
   events: {
     
   }
  });
 
 